import {ActionType, createAction} from 'typesafe-actions';
import {AvgHistory, TravelTimeHistory} from '../../../../interfaces/History';

type AvgPayload = {
    dataType: 'avg';
    mapSourceID: string;
    featureID: number | string;
    locationID: string;
    timestamp: number;
    data: AvgHistory;
};

type TravelPayload = {
    dataType: 'travel-time-v2';
    mapSourceID: string;
    featureID: number | string;
    locationID: string;
    timestamp: number;
    data: TravelTimeHistory;
};

export type HistoryPayload = AvgPayload | TravelPayload;

export const viewerApiServiceReceivedHistoricalData = createAction(
    'VIEWER_API_SERVICE_RECEIVED_HISTORICAL_DATA',
    (action) => (payload: HistoryPayload) => action(payload),
);

export const viewerApiServiceReceivingHistoricalDataFailedWithUnauthorizedError = createAction(
    'VIEWER_API_SERVICE_RECEIVING_HISTORICAL_DATA_FAILED_WITH_UNAUTHORIZED_ERROR',
    (action) => () => action({}),
);

export const viewerApiServiceReceivingHistoricalDataFailedWithUnexpectedError = createAction(
    'VIEWER_API_SERVICE_RECEIVING_HISTORICAL_DATA_FAILED_WITH_UNEXPECTED_ERROR',
    (action) => () => action({}),
);

export type HistoricalDataDataActionTypes =
    | ActionType<typeof viewerApiServiceReceivedHistoricalData>
    | ActionType<typeof viewerApiServiceReceivingHistoricalDataFailedWithUnauthorizedError>
    | ActionType<typeof viewerApiServiceReceivingHistoricalDataFailedWithUnexpectedError>;
